// Componente para exibir indicador visual de lock
import { Lock, AlertCircle, CheckCircle2 } from 'lucide-react';
import { LockInfo } from '@/hooks/useLock';
import { useI18n } from '@/contexts/i18n-hook';

interface LockIndicatorProps {
  lockInfo: LockInfo | null;
  eMeuLock: boolean;
  bloqueadoPorOutro: boolean;
  className?: string;
}

export function LockIndicator({
  lockInfo,
  eMeuLock,
  bloqueadoPorOutro,
  className = '',
}: LockIndicatorProps) {
  const { t, formatarDataHora } = useI18n();

  if (!lockInfo || !lockInfo.bloqueado) {
    return null;
  }

  // PRIORIDADE: Se é meu lock, mostrar indicador positivo (não mostrar aviso de bloqueio)
  if (eMeuLock) {
    const expiresAt = lockInfo.lock?.expiresAt
      ? new Date(lockInfo.lock.expiresAt)
      : null;

    return (
      <div
        className={`flex items-center gap-2 px-4 py-2 bg-blue-50 border border-blue-200 rounded-md ${className}`}
      >
        <Lock className="h-5 w-5 text-blue-600 flex-shrink-0" />
        <div className="flex-1">
          <p className="text-sm font-medium text-blue-800">
            {t('layout.lock.meuLock')}
          </p>
          {expiresAt && (
            <p className="text-xs text-blue-700 mt-1">
              {t('layout.lock.meuLockExpira', { data: formatarDataHora(expiresAt) })}
            </p>
          )}
        </div>
        <CheckCircle2 className="h-5 w-5 text-blue-600 flex-shrink-0" />
      </div>
    );
  }

  // Se está bloqueado por outro usuário, mostrar aviso
  if (bloqueadoPorOutro) {
    const expiresAt = lockInfo.lock?.expiresAt
      ? new Date(lockInfo.lock.expiresAt)
      : null;

    return (
      <div
        className={`flex items-center gap-2 px-4 py-2 bg-yellow-50 border border-yellow-200 rounded-md ${className}`}
      >
        <AlertCircle className="h-5 w-5 text-yellow-600 flex-shrink-0" />
        <div className="flex-1">
          <p className="text-sm font-medium text-yellow-800">
            {t('layout.lock.lockDeOutro')}
          </p>
          {lockInfo.lock?.usuarioNome && (
            <p className="text-xs text-yellow-700 mt-1">
              <strong>{t('layout.lock.editandoPor')}</strong> {lockInfo.lock.usuarioNome}
            </p>
          )}
          {expiresAt && (
            <p className="text-xs text-yellow-700">
              {t('layout.lock.expiraEm', { data: formatarDataHora(expiresAt) })}
            </p>
          )}
          <p className="text-xs text-yellow-600 mt-1 italic">
            {t('layout.lock.avisoBloqueio')}
          </p>
        </div>
      </div>
    );
  }

  return null;
}

